import angular from 'angular';

import translationsModuleName from '../../../../../lib/translation';

import serviceModuleName from '../../../../../lib/service';
import opportunityDisplayBoxModule from '../opportunityDisplayBox';

// Component
import component from './opportunitiesPanel.component';

const moduleName = 'staff.dashboardScreen.opportunitiesPanel';
let module = angular.module(moduleName, [
  translationsModuleName,
  serviceModuleName,
  opportunityDisplayBoxModule.name,
]);

module.component('opportunitiesPanel', component);

export default module;
